import React from 'react';
import { Verification } from '../../../types/verification';
import { VerificationCard } from './VerificationCard';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  verifications: Verification[];
  onApprove: (verification: Verification) => void;
  onReject: (verification: Verification) => void;
  onDelete: (verification: Verification) => void;
  copiedField: string | null;
  onCopy: (text: string, field: string) => void;
};

export const VerificationList = ({
  verifications,
  onApprove,
  onReject,
  onDelete,
  copiedField,
  onCopy
}: Props) => {
  const { translations } = useLanguage();

  if (verifications.length === 0) {
    return (
      <div className="text-center py-12 bg-white rounded-lg">
        <p className="text-gray-500">
          {translations?.verificationApproval?.noResults || 'No verifications found matching the filters'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6">
      {verifications.map((verification) => (
        <VerificationCard
          key={verification.id}
          verification={verification}
          onApprove={() => onApprove(verification)}
          onReject={() => onReject(verification)}
          onDelete={() => onDelete(verification)}
          copiedField={copiedField}
          onCopy={onCopy}
        />
      ))}
    </div>
  );
};
